var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgencySelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8333 31.8333H26.2333C24.9265 31.8333 24.2731 31.8333 23.7739 32.0877C23.3349 32.3114 22.9779 32.6683 22.7542 33.1074C22.4999 33.6065 22.4999 34.2599 22.4999 35.5667V43.5M43.4999 43.5V26.2333C43.4999 24.9265 43.4999 24.2731 43.2456 23.774C43.0219 23.335 42.6649 22.978 42.2259 22.7543C41.7268 22.5 41.0734 22.5 39.7666 22.5H35.5666C34.2598 22.5 33.6064 22.5 33.1073 22.7543C32.6682 22.978 32.3113 23.335 32.0876 23.774C31.8333 24.2731 31.8333 24.9265 31.8333 26.2333V43.5M44.6666 43.5H21.3333M35.9166 27.1667H39.4166M35.9166 31.8333H39.4166M35.9166 36.5H39.4166",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencySelector);
export default __webpack_public_path__ + "static/media/agencySelector.50d29696db490c2662922a8dbe81ce48.svg";
export { ForwardRef as ReactComponent };